import GlobalStore from "../services/GlobalStore";
import { Video } from "../services/Video";
import { Container, Sprite } from "pixi.js";

type SceneProps = {
  parent: Container;
  name: string;
  bgVideoPath?: string;
  bgImagePath?: string;
};

class Scene {
  parent: Container;
  name: string;
  visible: boolean;

  protected bgContainer: Container = new Container();
  protected contentContainer: Container = new Container();

  bgImage: Sprite | undefined = undefined;
  bgVideo: Video | undefined = undefined;
  bgVideoLoaded: boolean = false;
  topZ: number = 2;

  constructor({ parent, name, bgVideoPath, bgImagePath }: SceneProps) {
    this.parent = parent;
    this.name = name;
    this.visible = false;

    parent.addChild(this.bgContainer);
    GlobalStore.getLayers().background.attach(this.bgContainer);
    this.bgContainer.visible = this.visible;

    parent.addChild(this.contentContainer);
    GlobalStore.getLayers().content.attach(this.contentContainer);
    this.contentContainer.visible = this.visible;

    if (bgImagePath !== undefined) {
      this.loadBgImage(bgImagePath);
      if (this.bgImage !== undefined) {
        // this.bgImage.width = app.screen.width;
        // this.bgImage.height = app.screen.height;
        // this.bgImage.visible = this.visible;
        this.bgContainer.addChild(this.bgImage);

        // this.bgImage.zIndex = 0;
      }
    }

    if (bgVideoPath !== undefined) {
      this.loadBgVideo(bgVideoPath);
      if (this.bgVideo !== undefined) {
        this.bgVideoLoaded = true;
        this.bgVideo.width = 1920;
        this.bgVideo.height = 1080;
        this.bgVideo.visible = false;
        this.bgVideo.volume = 0;
        this.bgContainer.addChild(this.bgVideo);

        if (this.visible) {
          this.bgVideo.visible = true;
          this.bgVideo.play();
        }

        // this.bgVideo.zIndex = 1;
      }
    }

    this.loadBgImage = this.loadBgImage.bind(this);
    this.loadBgVideo = this.loadBgVideo.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.destroy = this.destroy.bind(this);
  }

  show() {
    if (this.visible) return;

    this.visible = true;

    this.bgContainer.visible = true;
    this.contentContainer.visible = true;

    if (this.bgVideo) {
      this.bgVideo.volume = 0.25;
      // this.bgVideo.visible = true;
      this.bgVideo.play();
    }
    console.log(`Scene ${this.name} is shown`);
  }

  public hide() {
    if (!this.visible) return;

    this.visible = false;
    this.bgContainer.visible = false;
    this.contentContainer.visible = false;

    if (this.bgVideo) {
      this.bgVideo.stop();
      // this.bgVideo.visible = false;
    }

    console.log(`Scene ${this.name} is hidden`);
  }

  private loadBgVideo(path: string) {
    // this.bgVideo = new Video({
    //   texture: await Assets.load(path),
    // });
    const ticker = GlobalStore.getApp()?.ticker;
    this.bgVideo = Video.fromAlias(path, {
      ticker: ticker,
    });
  }

  private loadBgImage(path: string) {
    console.log(`Loading sprite from ${path}`);
    this.bgImage = Sprite.from(path);
    // this.bgImage = Sprite.from(await Assets.load(path));
  }

  public destroy() {
    this.parent.removeChild(this.bgContainer);
    this.parent.removeChild(this.contentContainer);
  }
}

export default Scene;
